export default __webpack_public_path__ + "media/megamenu-4.34db0e91.svg";